var map = {
	"./add.svg": "31bf",
	"./card-top.svg": "8115",
	"./created.svg": "8acc",
	"./edit.svg": "a9fa",
	"./farm.svg": "db5e",
	"./hatchery.svg": "c2ce",
	"./master-entry.svg": "2d19",
	"./no-hatchery.svg": "f13c",
	"./purchase.svg": "01de",
	"./setter.svg": "66ee",
	"./single-hatchery.svg": "7986",
	"./user.svg": "aef5",
	"./users.svg": "1fff",
	"./view.svg": "4c10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3101";